import { RefObject, useEffect } from "react";
import { ExtendedVisTimeline } from "@/shared/types";

export const useTimelineSizing = (
  containerRef: RefObject<HTMLDivElement>,
  timelineRef: RefObject<ExtendedVisTimeline>
) => {
  useEffect(() => {
    if (!containerRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === containerRef.current && timelineRef.current) {
          timelineRef.current.setOptions({
            height: `${entry.contentRect.height - 62}px`,
          });
        }
      }
    });

    resizeObserver.observe(containerRef.current);
    return () => resizeObserver.disconnect();
  }, []);
};
